// =====================================================================
// scribeService (Clara Scribe Fase A / S61) — chamadas axios pro scribe (SOAP por IA).
// Endpoints (isAuth no backend; multi-tenant por companyId do JWT):
//   GET    /scribe/config-status         -> { asr, llm, provider }  (feature ligada?)
//   POST   /scribe/sessions              -> sessão criada (exige consentimento)
//   GET    /scribe/sessions/:id          -> poll (status + transcript + soap_draft)
//   POST   /scribe/sessions/:id/audio    -> envia o áudio (multipart "audio")
//   POST   /scribe/sessions/:id/process  -> dispara ASR -> SOAP (apaga o áudio)
//   POST   /scribe/sessions/:id/apply    -> cria/atualiza um encounter a partir do rascunho
//   POST   /scribe/sessions/:id/link     -> liga a um encounter salvo + marca ai_* (CFM 2.454)
//   DELETE /scribe/sessions/:id          -> descarta (apaga áudio/transcript)
// =====================================================================
import api from "./api";

export const scribeConfigStatus = async () => {
  const { data } = await api.get(`/scribe/config-status`);
  return data; // { asr, llm, provider }
};

export const createScribeSession = async (payload) => {
  const { data } = await api.post(`/scribe/sessions`, payload || {});
  return data;
};

export const getScribeSession = async (id) => {
  const { data } = await api.get(`/scribe/sessions/${id}`);
  return data;
};

export const uploadScribeAudio = async (id, blob, filename = "consulta.webm") => {
  const fd = new FormData();
  fd.append("audio", blob, filename);
  const { data } = await api.post(`/scribe/sessions/${id}/audio`, fd, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data;
};

export const processScribeSession = async (id) => {
  const { data } = await api.post(`/scribe/sessions/${id}/process`);
  return data;
};

export const applyScribeDraft = async (id, payload) => {
  const { data } = await api.post(`/scribe/sessions/${id}/apply`, payload || {});
  return data;
};

export const linkScribeSession = async (id, encounterId) => {
  const { data } = await api.post(`/scribe/sessions/${id}/link`, { encounterId });
  return data;
};

export const discardScribeSession = async (id) => {
  const { data } = await api.delete(`/scribe/sessions/${id}`);
  return data;
};

// Fase B — cruza a "receita sugerida" do rascunho com o receituário da clínica.
export const scribePrescriptionSuggestions = async (id) => {
  const { data } = await api.get(`/scribe/sessions/${id}/prescription-suggestions`);
  return data; // { suggestions: [{ nome, motivo, matches: [{ id, displayName, folder, posology, bodyPreview }] }] }
};

export const SCRIBE_STATUS_LABELS = {
  created: "Pronta",
  uploaded: "Áudio recebido",
  transcribing: "Transcrevendo…",
  drafting: "Gerando SOAP…",
  drafted: "Rascunho pronto",
  applied: "Aplicada",
  error: "Erro",
  discarded: "Descartada"
};

// Traduz o erro do backend (AppError -> { error: "ERR_..." }) numa mensagem amigável.
export const scribeErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_SCRIBE_CONSENT_REQUIRED: "Marque o consentimento do paciente antes de gravar.",
    ERR_SCRIBE_NO_AUDIO: "Nenhum áudio enviado ainda.",
    ERR_SCRIBE_NO_FILE: "O arquivo de áudio não chegou.",
    ERR_SCRIBE_SESSION_NOT_FOUND: "Sessão de gravação não encontrada.",
    ERR_SCRIBE_PATIENT_REQUIRED: "Vincule um paciente para aplicar o rascunho.",
    ERR_PATIENT_NOT_FOUND: "Paciente não encontrado.",
    ERR_ENCOUNTER_NOT_FOUND: "Consulta não encontrada."
  };
  if (code && map[code]) return map[code];
  // mensagens de "não configurado" vêm com prefixo explicativo do backend
  if (code && typeof code === "string") {
    if (code.indexOf("ASR_NOT_CONFIGURED") >= 0) return "Transcrição ainda não configurada (aguardando chave do ASR + DPA).";
    if (code.indexOf("LLM_NOT_CONFIGURED") >= 0) return "Geração de SOAP ainda não configurada (aguardando chave do Claude/Bedrock).";
    if (!code.startsWith("ERR_")) return code;
  }
  return "Não foi possível concluir a operação do scribe.";
};
